import React, { useState } from 'react';
import ProfileLanding from './features/landing/ProfileLanding';
import Desktop from './features/desktop/Desktop';
import CaseStudiesPage from './features/applications/case_studies/CaseStudiesPage';
import BlinkitCaseStudy from './features/applications/case_studies/BlinkitCaseStudy';
import RapidoCaseStudy from './features/applications/case_studies/RapidoCaseStudy';
import Experience3D from './features/applications/experience_3d/Experience3D';

const App = () => {
  const [showDesktop, setShowDesktop] = useState(false);
  const [showCaseStudiesPage, setShowCaseStudiesPage] = useState(false);
  const [activeCaseStudy, setActiveCaseStudy] = useState(null);
  const [show3DExperience, setShow3DExperience] = useState(false);

  const handleEnterDesktop = () => {
    setShowDesktop(true);
  };

  const handleExitDesktop = () => {
    setShowDesktop(false);
  };

  const handleOpenCaseStudiesPage = () => {
    setShowCaseStudiesPage(true);
  };

  const handleCloseCaseStudiesPage = () => {
    setShowCaseStudiesPage(false);
  };

  const handleSelectCaseStudy = (caseStudyType) => {
    setActiveCaseStudy(caseStudyType);
  };

  const handleCloseCaseStudy = () => {
    setActiveCaseStudy(null);
    setShowCaseStudiesPage(true);
  };

  const handleOpen3DExperience = () => {
    setShow3DExperience(true);
  };

  const handleClose3DExperience = () => {
    setShow3DExperience(false);
  };

  return (
    <>
      {show3DExperience ? (
        <Experience3D onClose={handleClose3DExperience} />
      ) : activeCaseStudy === 'blinkit' ? (
        <BlinkitCaseStudy onClose={handleCloseCaseStudy} />
      ) : activeCaseStudy === 'rapido' ? (
        <RapidoCaseStudy onClose={handleCloseCaseStudy} />
      ) : showCaseStudiesPage ? (
        <CaseStudiesPage 
          onClose={handleCloseCaseStudiesPage} 
          onSelectCaseStudy={handleSelectCaseStudy}
        />
      ) : showDesktop ? (
        <Desktop onClose={handleExitDesktop} />
      ) : (
        <ProfileLanding 
          onOpenDesktop={handleEnterDesktop}
          onOpenCaseStudy={handleOpenCaseStudiesPage}
          onOpen3DExperience={handleOpen3DExperience}
        />
      )}
    </>
  );
};

export default App;
